import React, { useState } from "react";

import IconButton from "@mui/material/IconButton";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

export default function CampanhaBeneficios({
  formBeneficio,
  setFormBeneficio,
  basesCalculoBeneficio,
  mostrarValorEur,
  mostrarValorUnidade,
  mostrarPercentagem,
  mostrarOferta,
  materiaisCombo,
  carregarMateriaisCombo,
  materialLabel,
  ofertaInput,
  setOfertaInput,
  guardarBeneficio,
  beneficios,
  editarBeneficio,
  pedirEliminarBeneficio,
}) {
  const [openInfoBeneficios, setOpenInfoBeneficios] = useState(false);

  const descricaoBeneficio = (b) => {
    const tipo = String(b.tipobeneficio || "");
    const base = String(b.basecalculo || "");
    const aplica = Number(b.aplicaporconjunto || 0);

    if (tipo === "VALOR_FIXO" && base === "CONJUNTO" && aplica === 0) {
      return "Valor fixo único";
    }

    if (tipo === "VALOR_FIXO" && base === "CONJUNTO") {
      return "Valor fixo por conjunto";
    }

    if (tipo === "VALOR_POR_UNIDADE") {
      return "Valor por unidade";
    }

    if (tipo === "CUSTO_MATERIAL" && (base === "QTD_RESERVADA" || base === "OFERTA_REEMBOLSADA")) {
      return "Reembolso pelo custo do material";
    }

    if (tipo === "PERCENTAGEM" && base === "VALOR") {
      return "Percentagem sobre valor";
    }

    if (tipo === "PERCENTAGEM" && base === "VALOR_SEM_IEC") {
      return "Percentagem sem IEC";
    }

    if (tipo === "PERCENTAGEM" && base === "LINHA") {
      return "Percentagem por linha";
    }

    if (tipo === "PERCENTAGEM" && base === "QTD") {
      return "Percentagem por quantidade";
    }

    if (tipo === "PERCENTAGEM" && base === "VOLUME") {
      return "Percentagem por volume";
    }

    if (tipo === "ESPECIE" && aplica === 0) {
      return "Oferta em espécie única";
    }

    if (tipo === "ESPECIE") {
      return "Oferta em espécie por conjunto";
    }

    return `${tipo} ${base}`;
  };

  return (
    <MDBox mt={2} p={2} sx={{ border: "1px solid #e0e0e0", borderRadius: 2 }}>
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems={{ xs: "stretch", sm: "center" }}
        flexDirection={{ xs: "column", sm: "row" }}
        gap={1}
        mb={1}
        sx={{
          "& .MuiButton-root": {
            width: { xs: "100%", sm: "auto" },
          },
        }}
      >
        <MDTypography variant="h6">Benefícios</MDTypography>

        <MDButton color="info" size="small" onClick={() => setOpenInfoBeneficios(true)}>
          Info
        </MDButton>
      </MDBox>

      <MDBox
        display="grid"
        gridTemplateColumns={{
          xs: "1fr",
          sm: "1fr 1fr",
          lg: "1fr 1fr auto auto auto auto auto",
        }}
        gap={1}
        mb={2}
        alignItems="flex-end"
        sx={{
          maxWidth: "100%",
          "& .MuiButton-root": {
            width: { xs: "100%", lg: "auto" },
          },
        }}
      >
        <select
          value={`${formBeneficio.tipobeneficio}|${formBeneficio.basecalculo}`}
          onChange={(e) => {
            const [tipobeneficio, basecalculo] = e.target.value.split("|");

            setFormBeneficio((p) => ({
              ...p,
              tipobeneficio,
              basecalculo,
              aplicaporconjunto:
                tipobeneficio === "VALOR_FIXO" && basecalculo === "REEMBOLSO_UNICO"
                  ? 0
                  : tipobeneficio === "VALOR_FIXO" && basecalculo === "CONJUNTO"
                  ? 1
                  : p.aplicaporconjunto,
              valor_eur: "",
              valor_por_unidade: "",
              percentagem: "",
              refmaterialoferta: "",
              qtdoferta: "",
              unidadeoferta: "",
            }));

            setOfertaInput("");
          }}
          style={{
            padding: 9,
            borderRadius: 6,
            border: "1px solid #d2d6da",
            width: "100%",
            minWidth: 0,
          }}
        >
          <option value="VALOR_FIXO|REEMBOLSO_UNICO">Valor fixo único</option>
          <option value="VALOR_FIXO|CONJUNTO">Valor fixo por conjunto</option>
          <option value="VALOR_POR_UNIDADE|QTD">Valor por unidade</option>
          <option value="CUSTO_MATERIAL|QTD_RESERVADA">Reembolso pelo custo do material</option>
          <option value="PERCENTAGEM|VALOR">Percentagem sobre valor</option>
          <option value="PERCENTAGEM|VALOR_SEM_IEC">Percentagem sem IEC</option>
          <option value="PERCENTAGEM|LINHA">Percentagem por linha</option>
          <option value="PERCENTAGEM|QTD">Percentagem por quantidade</option>
          <option value="PERCENTAGEM|VOLUME">Percentagem por volume</option>
          <option value="ESPECIE|CONJUNTO">Oferta em espécie por conjunto</option>
          <option value="ESPECIE|REEMBOLSO_UNICO">Oferta em espécie única</option>
        </select>

        {mostrarValorEur && (
          <MDBox sx={{ minWidth: 0, width: "100%" }}>
            <MDInput
              label="Valor €"
              type="number"
              value={formBeneficio.valor_eur}
              onChange={(e) => setFormBeneficio((p) => ({ ...p, valor_eur: e.target.value }))}
              fullWidth
            />
          </MDBox>
        )}

        {mostrarValorUnidade && (
          <MDBox sx={{ minWidth: 0, width: "100%" }}>
            <MDInput
              label="Valor por unidade"
              type="number"
              value={formBeneficio.valor_por_unidade}
              onChange={(e) =>
                setFormBeneficio((p) => ({
                  ...p,
                  valor_por_unidade: e.target.value,
                }))
              }
              fullWidth
            />
          </MDBox>
        )}

        {mostrarPercentagem && (
          <MDBox sx={{ minWidth: 0, width: "100%" }}>
            <MDInput
              label="%"
              type="number"
              value={formBeneficio.percentagem}
              onChange={(e) =>
                setFormBeneficio((p) => ({
                  ...p,
                  percentagem: e.target.value,
                }))
              }
              fullWidth
            />
          </MDBox>
        )}

        <MDBox sx={{ minWidth: 0, width: "100%" }}>
          <MDInput
            label="Aplica/conj."
            type="number"
            value={formBeneficio.aplicaporconjunto}
            onChange={(e) =>
              setFormBeneficio((p) => ({
                ...p,
                aplicaporconjunto: e.target.value,
              }))
            }
            fullWidth
          />
        </MDBox>

        <MDButton color="success" onClick={guardarBeneficio}>
          {formBeneficio.id ? "Atualizar" : "Adicionar"}
        </MDButton>
      </MDBox>

      {mostrarOferta && (
        <MDBox
          display="grid"
          gridTemplateColumns={{
            xs: "1fr",
            md: "2.4fr 0.8fr 0.9fr 1.2fr",
          }}
          gap={1}
          mb={2}
        >
          <Autocomplete
            size="small"
            options={materiaisCombo}
            filterOptions={(x) => x}
            inputValue={ofertaInput}
            getOptionLabel={materialLabel}
            value={materiaisCombo.find((m) => m.ref === formBeneficio.refmaterialoferta) || null}
            onInputChange={(_, value, reason) => {
              if (reason === "input") {
                setOfertaInput(value);
                setFormBeneficio((p) => ({
                  ...p,
                  refmaterialoferta: "",
                  unidadeoferta: "",
                }));
                carregarMateriaisCombo(value);
              }

              if (reason === "clear") {
                setOfertaInput("");
                setFormBeneficio((p) => ({
                  ...p,
                  refmaterialoferta: "",
                  unidadeoferta: "",
                }));
              }
            }}
            onChange={(_, value) => {
              setFormBeneficio((p) => ({
                ...p,
                refmaterialoferta: value?.ref || "",
                unidadeoferta: value?.refmaterialunidade || "",
              }));

              setOfertaInput(value ? materialLabel(value) : "");
            }}
            renderInput={(params) => (
              <TextField {...params} label="Material oferta" placeholder="Pesquisar..." />
            )}
          />

          <MDInput
            label="Qtd oferta"
            type="number"
            value={formBeneficio.qtdoferta}
            onChange={(e) =>
              setFormBeneficio((p) => ({
                ...p,
                qtdoferta: e.target.value,
              }))
            }
            fullWidth
          />

          <MDInput
            label="Unidade oferta"
            value={formBeneficio.unidadeoferta}
            onChange={(e) =>
              setFormBeneficio((p) => ({
                ...p,
                unidadeoferta: e.target.value,
              }))
            }
            fullWidth
          />

          <MDInput
            label="Obs"
            value={formBeneficio.obs}
            onChange={(e) => setFormBeneficio((p) => ({ ...p, obs: e.target.value }))}
            fullWidth
          />
        </MDBox>
      )}

      {beneficios.map((b) => {
        const beneficioAutomatico =
          String(b.tipobeneficio || "") === "CUSTO_MATERIAL" &&
          String(b.basecalculo || "") === "OFERTA_REEMBOLSADA";

        return (
          <MDBox
            key={b.id}
            display="grid"
            gridTemplateColumns={{
              xs: "1fr",
              md: "1fr 1fr 1fr 1fr 1fr 1fr 2fr auto",
            }}
            gap={1}
            alignItems="center"
            py={0.5}
            sx={{ borderTop: "1px solid #e0e0e0" }}
          >
            <MDTypography variant="caption">{descricaoBeneficio(b)}</MDTypography>

            <MDTypography variant="caption">
              {!beneficioAutomatico && b.valor_por_unidade != null && b.valor_por_unidade !== ""
                ? Number(b.valor_por_unidade).toFixed(3)
                : ""}
            </MDTypography>

            <MDTypography variant="caption">
              {!beneficioAutomatico && b.valor_eur != null && b.valor_eur !== ""
                ? Number(b.valor_eur).toFixed(3)
                : ""}
            </MDTypography>

            <MDTypography variant="caption">
              {!beneficioAutomatico && b.percentagem != null && b.percentagem !== ""
                ? Number(b.percentagem).toFixed(3)
                : ""}
            </MDTypography>

            <MDTypography variant="caption">
              {b.refmaterialoferta
                ? `${b.qtdoferta || ""} ${b.unidadeoferta || ""} ${
                    b.materialoferta || b.refmaterialoferta
                  } (${b.refmaterialoferta})${b.obs ? ` — ${b.obs}` : ""}`
                : b.obs || ""}
            </MDTypography>

            <MDBox display="flex" justifyContent="flex-end" gap={0.5}>
              {!beneficioAutomatico && (
                <>
                  <IconButton
                    size="small"
                    color="warning"
                    onClick={() => editarBeneficio(b)}
                    title="Editar"
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>

                  <IconButton
                    size="small"
                    color="error"
                    onClick={() => pedirEliminarBeneficio(b)}
                    title="Eliminar"
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </>
              )}
            </MDBox>
          </MDBox>
        );
      })}
    </MDBox>
  );
}
